/* globals Forms */
window['portal/passwords#edit'] = function () {
  Forms.initPasswordChecker()
}
